import { Component } from '@angular/core';
import { VarService } from './var.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(
    public varService: VarService
  ) { }

  onActivate(event) {
    document.getElementById('app-content-wrapper').scrollTo(0, 0);
  }
}
